const pages = {
  landings: [],
  company: [
    {
      title: 'About',
      href: '/about',
    },
    {
      title: 'Pricing',
      href: '/pricing',
    },
    {
      title: 'FAQ',
      href: '/faq',
    },
    {
      title: 'Contact',
      href: '/contact-page',
    },
    {
      title: 'Terms',
      href: '/company-terms',
    },
  ],
  account: [
    {
      title: 'Login',
      href: '/login',
    },
    {
      title: 'Register',
      href: '/register',
    },
  ],
  secondary: [
    {
      title: 'Help Centre',
      href: '/help-center',
    },
  ],
  blog: [],
  portfolio: [],
};

export default pages;
